import React from "react";
import "./HeaderLink.scss";
import { Link } from "react-router-dom";

interface HeaderLinkProps {
  linkName: string;
  link: string;
  isActive?: boolean; // Optional property
  children: React.ReactNode;
}
const HeaderLink: React.FC<HeaderLinkProps> = ({
  linkName,
  link,
  isActive = true, // Default to false if not provided
  children,
}) => {
  return (
    <div
      className={`col-start header-link card ${!isActive ? "disabled" : ""}`}
    >
      {link?.length && link.startsWith("#") ? (
        <a href={link}>
          {children}
          <h2>{linkName}</h2>
        </a>
      ) : isActive ? (
        <Link to={link}>
          {children}
          <h2>{linkName}</h2>
        </Link>
      ) : (
        <div>
          {children}
          <h2>{linkName}</h2>
        </div>
      )}
    </div>
  );
};

export default HeaderLink;
